import { api } from '@/lib/axios'
import { mitStand } from '@/lib/speichern'
import type { CalcClosing, CalcMaterialRow, CalcOverview, CalcPriceRefreshLine, CalcPricing, CalcPricingDraft, CalcScheme, CalcSchemeRow } from '../types/calculation.types'

/** AP-37 8. — Sätze & Aufschläge, Übersicht, Materialauszug, Preise aktualisieren. */
const basis = (id: string) => `/calculations/${id}`

export const fetchPricing = (id: string) => api.get<{ data: CalcPricing }>(`${basis(id)}/closing`).then((r) => r.data.data)
export const previewPricing = (id: string, draft: CalcPricingDraft) =>
  api.put<{ data: { before: CalcClosing; after: CalcClosing } }>(`${basis(id)}/closing`, draft, { params: { preview: 1 } }).then((r) => r.data.data)
export const applyPricing = (id: string, draft: CalcPricingDraft, stand: string) =>
  api.put<{ data: CalcPricing }>(`${basis(id)}/closing`, draft, mitStand(stand)).then((r) => r.data.data)

export const fetchOverview = (id: string) => api.get<{ data: CalcOverview }>(`${basis(id)}/overview`).then((r) => r.data.data)
export const fetchMaterialSummary = (id: string) => api.get<{ data: CalcMaterialRow[] }>(`${basis(id)}/material-summary`).then((r) => r.data.data)
export const copyMaterialSummary = (id: string, keys?: string[]) =>
  api.post<{ data: { copied: number } }>(`${basis(id)}/material-summary/copy`, { keys }).then((r) => r.data.data)
export const fetchPriceRefresh = (id: string) =>
  api.get<{ data: { days: number; lines: CalcPriceRefreshLine[] } }>(`${basis(id)}/price-refresh`).then((r) => r.data.data)
export const applyPriceRefresh = (id: string, lineIds: string[]) =>
  api.post<{ data: { updated: number } }>(`${basis(id)}/price-refresh`, { lineIds }).then((r) => r.data.data)

// ── Zuschlagsschemata des Mandanten (Einstellungen) ─────────────────────────

const schemata = '/calculation-settings/schemes'
export const fetchSchemesAll = () => api.get<{ data: CalcScheme[] }>(`${schemata}/all`).then((r) => r.data.data)
export const createScheme = (dto: { name: string; copyFromId?: string }) => api.post<{ data: CalcScheme }>(schemata, dto).then((r) => r.data.data)
export const schemeUrl = (sid: string) => `${schemata}/${sid}`
export const deleteScheme = (sid: string) => api.delete(schemeUrl(sid))
export const createSchemeRow = (sid: string, dto: { name: string; percent: number; appliesTo: string[]; basis?: string }) =>
  api.post<{ data: CalcSchemeRow }>(`${schemeUrl(sid)}/rows`, dto).then((r) => r.data.data)
export const schemeRowUrl = (sid: string, rid: string) => `${schemeUrl(sid)}/rows/${rid}`
export const deleteSchemeRow = (sid: string, rid: string) => api.delete(schemeRowUrl(sid, rid))
export const reorderSchemeRows = (sid: string, ids: string[]) =>
  api.post<{ data: CalcScheme }>(`${schemeUrl(sid)}/rows/reorder`, { ids }).then((r) => r.data.data)
